import { FC, useState } from 'react';

import { Dropdown, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import Delete from '@/assets/icons/icon-delete.svg?react';
import Edit from '@/assets/icons/icon-edit.svg?react';
import More from '@/assets/icons/icon-three-dots-vertical.svg?react';
import RNotificationCard from '@/components/RNotificationCard';

interface ActionsMenuProps {
  onDelete: () => void;
  onEdit: () => void;
}

export const ActionsMenu: FC<ActionsMenuProps> = ({ onDelete, onEdit }) => {
  const { t } = useTranslation();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const theme = useTheme();
  const handleMenuClick = (e: { key: string }) => {
    if (e.key === 'edit') {
      onEdit();
    }
    if (e.key === 'delete') {
      setModalVisible(true);
    }
  };
  const handleDeleteConfirm = () => {
    onDelete();
    setModalVisible(false);
  };

  const menuItems = [
    {
      key: 'edit',
      icon: <Edit width={16} height={16} />,
      label: t('organization.userManagement.actions.edit'),
      'data-testid': 'edit-user-btn',
    },
    {
      key: 'delete',
      icon: <Delete width={16} height={16} />,
      label: t('organization.userManagement.actions.delete'),
      'data-testid': 'delete-user-btn',
    },
  ];

  return (
    <>
      <Dropdown
        menu={{ items: menuItems, onClick: handleMenuClick }}
        trigger={['click']}
      >
        <Button
          className="default-icon-button"
          icon={<More fill={theme.colors.bluePrimary} />}
        />
      </Dropdown>
      <RNotificationCard
        title={t('organization.userManagement.deleteUser.title')}
        message={t('organization.userManagement.deleteUser.message')}
        type="warning"
        confirmText={t('organization.userManagement.deleteUser.confirmText')}
        cancelText={t('organization.userManagement.deleteUser.cancelText')}
        open={modalVisible}
        onConfirm={handleDeleteConfirm}
        onCancel={() => setModalVisible(false)}
      />
    </>
  );
};
